// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ReportsPage__panelTitle___BkjMn{margin-bottom:1rem}.ReportsPage__section___bfKg4{margin-bottom:2rem}.ReportsPage__section___bfKg4 iframe{min-height:800px}.ReportsPage__title___xhQAP{margin-bottom:1rem}", "",{"version":3,"sources":["webpack://./src/restaurantAdmin/reports/ReportsPage.scss"],"names":[],"mappings":"AAAA,iCACE,kBAAA,CAGF,8BACI,kBAAA,CAEA,qCACI,gBAAA,CAIR,4BACI,kBAAA","sourcesContent":[".panelTitle {\n  margin-bottom: 1rem;\n}\n\n.section {\n    margin-bottom: 2rem;\n\n    iframe {\n        min-height: 800px;\n    }\n}\n\n.title {\n    margin-bottom: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panelTitle": "ReportsPage__panelTitle___BkjMn",
	"section": "ReportsPage__section___bfKg4",
	"title": "ReportsPage__title___xhQAP"
};
export default ___CSS_LOADER_EXPORT___;
